import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private
        exact
        key="general-protocol"
        path="/general-protocol"
        component={Page} />
];

export default Routes;